module.exports = __webpack_public_path__ + "assets/img/season2-5b4710fa.png";